import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ImageViewModalComponent, type ImageViewModalProps,
} from './imageViewModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ImagesView: ImageViewModalProps;
  }
}
modalRenderer.register('ImagesView', ImageViewModalComponent);
